import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash Clock"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash-clock',
    templateUrl: './icon-cash-clock.component.html',
    styleUrls: ['./icon-cash-clock.component.scss'],
    standalone: false
})
export class IconCashClockComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
